import React from "react"
import { Box, Flex, Heading, Image } from "@chakra-ui/react"
import { useContentResolver } from "@app/hooks/useContentResolver"
import { useImageResolver } from "@app/hooks/useImageResolver"

type Props = {
  productHighlights: GatsbyTypes.SanityProduct["productHighlights"]
}

const ProductTabProductHighlights: React.FC<Props> = ({ productHighlights }) => {
  return (
    <Flex gap={{ base: 0, sm: "16px", lg: "40px" }} flexDir={{ base: "column", lg: "row" }}>
      <Box p={{ base: "16px", lg: "32px" }}>
        {productHighlights?.heading && (
          <Heading fontSize={{ base: 24, lg: 32 }} fontWeight={700} flex={{ base: "100%", lg: "30%" }} mb="32px">
            {productHighlights.heading}
          </Heading>
        )}
        <Flex justifyContent="space-between" gap={{ base: "16px", lg: "48px" }} flexDir={{ base: "column", lg: "row" }}>
          {productHighlights?.items?.map((item, index) => <ProductHighlightsItem key={index} item={item} />)}
        </Flex>
      </Box>
    </Flex>
  )
}

type ProductHighlightsItemProps = {
  item: GatsbyTypes.SanityImageText
}

const ProductHighlightsItem: React.FC<ProductHighlightsItemProps> = ({ item }) => {
  const { resolvedContent } = useContentResolver(item?.content)
  const { resolvedImage } = useImageResolver(item?.image)

  return (
    <Box flex="50%">
      <Flex gap={{ base: "16px", sm: "12px" }} flexDir={{ base: "column-reverse", sm: "row" }}>
        {resolvedImage && (
          <Image {...resolvedImage} objectFit="cover" w="150px" h="150px" mx={{ base: "auto", sm: 0 }} borderRadius="50%" />
        )}
        <Box textAlign={{ base: "center", sm: "left" }}> {resolvedContent} </Box>
      </Flex>
    </Box>
  )
}

export default React.memo(ProductTabProductHighlights)
